var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82324 6.21289C7.88461 6.21295 7.92784 6.2296 7.97754 6.2793L12.0967 10.3994C12.1356 10.4383 12.1504 10.464 12.1553 10.4756V10.4766C12.1631 10.4955 12.168 10.518 12.168 10.5479C12.1679 10.5778 12.1632 10.6001 12.1553 10.6191C12.1504 10.6307 12.1356 10.6573 12.0967 10.6963L7.95605 14.8369C7.90673 14.8862 7.87362 14.8951 7.83105 14.8936C7.77479 14.8915 7.72663 14.8741 7.66895 14.8164C7.61915 14.7666 7.60254 14.7237 7.60254 14.6621C7.60257 14.6007 7.6192 14.5576 7.66895 14.5078L11.6289 10.5479L7.64746 6.56641C7.59841 6.51727 7.59031 6.48383 7.5918 6.44141C7.59385 6.38514 7.61129 6.33698 7.66895 6.2793C7.71874 6.2295 7.7617 6.21289 7.82324 6.21289Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.81543e01a50b7699876c876dc7fa8195.svg";
export { ForwardRef as ReactComponent };